import React, { useRef, useEffect } from 'react';

interface Props {
  src?: string;
  content?: string;
  className?: string;
  setIsScriptLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

function InlineScript({ src, content, className = '', setIsScriptLoading }: Props) {
  const scriptRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scriptRef.current) {
      const script = document.createElement('script');

      // Set loading to true when we start
      setIsScriptLoading(true);

      const handleLoad = () => {
        // Set loading to false when script is loaded
        setIsScriptLoading(false);
      };

      if (src) {
        script.src = src;
        script.onload = handleLoad;
      } else if (content) {
        script.text = content;

        // For inline scripts, we need to manually trigger the onload
        setTimeout(handleLoad, 0);
      }

      script.async = true;

      scriptRef.current.appendChild(script);

      return () => {
        if (scriptRef.current) {
          scriptRef.current.removeChild(script);
        }

        // Reset loading state on unmount
        setIsScriptLoading(false);
      };
    }
  }, [src, content, setIsScriptLoading]);

  return (
    <div
      ref={scriptRef}
      className={className}
    ></div>
  );
}

export default InlineScript;
